export default __webpack_public_path__ + "static/tech-15dc755fb38a33361247b1d1883a2b00.svg";